import React from 'react'
import { Field, Input, InputOnChangeData, Textarea, TextareaOnChangeData } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'
import { t } from '../../../i18n/i18n'

type TextInputProps = {
   label: string
   value: string | number | null
   onChange?: (ev: any, data: TextareaOnChangeData | InputOnChangeData) => void
   disabled?: boolean
   multiline?: boolean
   className?: string
   rows?: number
   type?: 'number' | 'search' | 'time' | 'text' | 'email' | 'password' | 'tel' | 'url' | 'date' | 'datetime-local' | 'month' | 'week'
}

export const TextInput = ({ label, value, onChange, disabled, multiline, className, rows, type }: TextInputProps) => {
   return (
      <Field className={className ?? ''} style={{ fontWeight: 'semi' }} label={label}>
         {multiline ? (
            <Textarea
               rows={rows}
               value={value?.toString() ?? ''}
               onChange={(e, d) => onChange && onChange(e, d)}
               resize={'vertical'}
               disabled={disabled ?? false}
            />
         ) : (
            <Input
               style={{ minWidth: '0px', width: '100%' }}
               type={type}
               value={value?.toString() ?? ''}
               onChange={(e, d) => onChange && onChange(e, d)}
               disabled={disabled ?? false}
            />
         )}
      </Field>
   )
}

type ControlledTextInputProps = {
   name: any
   control: Control<any>
   label?: string
   disabled?: boolean
   multiline?: boolean
   required?: boolean
   rows?: number
   type?: 'number' | 'search' | 'time' | 'text' | 'email' | 'password' | 'tel' | 'url' | 'date' | 'datetime-local' | 'month' | 'week'
}
export const ControlledTextInput = ({ name, control, disabled, label, multiline, required, rows, type }: ControlledTextInputProps) => {
   const handlePhoneNumberInput = (e: React.FormEvent<HTMLInputElement>) => {
      if (type === 'tel') {
         const input = e.currentTarget.value
         e.currentTarget.value = input.replace(/[^0-9]/g, '')
      }
   }
   return (
      <Controller
         name={name}
         control={control}
         rules={{
            required: required ? t('RequiredField') : false,
            pattern:
               type === 'email'
                  ? {
                       value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                       message: t('InvalidEmailAddress'),
                    }
                  : undefined,
         }}
         render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Field label={label} required={required ?? false} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
               {multiline ? (
                  <Textarea rows={rows} value={value ?? ''} onChange={onChange} resize={'vertical'} disabled={disabled ?? false} />
               ) : (
                  <Input type={type} onInput={handlePhoneNumberInput} value={value ?? ''} onChange={onChange} disabled={disabled ?? false} />
               )}
            </Field>
         )}
      />
   )
}
